<template>
  <div>
    <p v-if="address"><b>{{$t('account.map.address')}}:</b> {{address}} </p>
    <b-alert v-if="!center && !centerList" variant="danger" show>{{$t('account.map.noAddress')}}</b-alert>
    <div v-if="coordsToTrack" class="animation-handlers">
      <b-button variant="primary" @click="start">{{$t('account.map.start')}}</b-button>
      <b-button variant='danger' @click="stop">{{$t('account.map.stop')}}</b-button>
      <b-button variant='warning' @click="reset">{{$t('account.map.reset')}}</b-button>
    </div>
    <LMap v-if="center"
      ref="mapRef" 
      style="height: 350px" 
      :zoom="zoom" 
      :center="center" 
      :crs="crs" 
      @baselayerchange="setCRS">
      <LControlLayers />
      <LTileLayer
        v-for="tileProvider in tileProviders"
        :key="tileProvider.name"
        :name="tileProvider.name"
        :visible="tileProvider.visible"
        :url="tileProvider.url"
        :attribution="tileProvider.attribution"
        :subdomains="tileProvider.subdomains"
        layer-type="base"
        />
      <LPolyline v-if="coordsToTrack" ref="poly" color="green" :lat-lngs="coordsToTrack" />
      <LMarker v-else :lat-lng="center" ></LMarker>
    </LMap>
    <LMap v-if="centerList"
       ref="mapRef" 
        class="map"
      :zoom="zoom" 
      :center="centerList[0]" 
      :crs="crs" 
      @baselayerchange="setCRS">
      <LControlLayers />
      <LTileLayer
        v-for="tileProvider in tileProviders"
        :key="tileProvider.name"
        :name="tileProvider.name"
        :visible="tileProvider.visible"
        :url="tileProvider.url"
        :attribution="tileProvider.attribution"
        :subdomains="tileProvider.subdomains"
        layer-type="base"
        />
      <LMarker v-for="(cl, i) in centerList" :key="i" :lat-lng="cl" :icon="addressList[i].icon"  class="blinking">
        <LPopup>
          <strong> {{addressList[i].customer.name }}</strong>
          <div style=" overflow-wrap: break-word;" v-html="addressList[i].content"></div>
        </LPopup>

      </LMarker>
    </LMap>
  </div>
</template>
<script>
import L from 'leaflet'
import { Icon, CRS } from 'leaflet';
import { LMap, LTileLayer, LMarker, LControlLayers, LPolyline, LPopup, LTooltip } from 'vue2-leaflet';
import { EsriProvider } from 'leaflet-geosearch'
import animateMarker from 'leaflet.animatedmarker/src/AnimatedMarker'
/**import car from '../assets/img/car.png'

// Animated Marker Icon
const icon = L.icon({
    iconUrl: car,
    iconSize: [25, 25],
    iconAnchor: [23, 23]
  })**/

// Displaying Marker
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
  name: 'Maps',
  components: {
    LMap, LTileLayer, LMarker, LControlLayers, LPolyline, LTooltip, LPopup
  },
  props: {
    coordinates: Object, // is to center the map
    address: String,
    coordsToTrack: Array,
    addressList: Array,
    icon: Object
  },
  data() {
    return {
      map: {},
      animatedMarker: {},
      addressFailed: null,
      crss: [
        CRS.EPSG3857, // Default
        CRS.EPSG3395 // Yandex
      ],
      crsIndex: 0,
      center: this.coordinates ? [this.coordinates.lat, this.coordinates.lng] : null,
      centerList :null,
      zoom: 12,
      tileProviders: [
        {
          name: 'Google Maps',
          visible: true,
          attribution: '<div style="font-size: 11px; margin:0"> &copy; <a target="_blank" href="https://www.sanatteknoloji.com.tr">Sanat Teknoloji</a> tarafından geliştirilmiştir. <div/>',
          url: 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
          subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        },
        {
          name: 'Yandex Maps',
          visible: false,
          attribution: '<div style="font-size: 11px; margin:0"> &copy; <a target="_blank" href="https://www.sanatteknoloji.com.tr">Sanat Teknoloji</a> tarafından geliştirilmiştir. <div/>',
          url: 'https://core-renderer-tiles.maps.yandex.net/tiles?l=map&x={x}&y={y}&z={z}&scale=1&lang=tr_TR',
          subdomains: '1,2,3,4',
        },
        {
          name: 'OpenStreet',
          visible: false,
          attribution: '<div style="font-size: 11px; margin:0"> &copy; <a target="_blank" href="https://www.sanatteknoloji.com.tr">Sanat Teknoloji</a> tarafından geliştirilmiştir. <div/>',
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        },
        {
          name: 'OpenTopo',
          visible: false,
          attribution: '<div style="font-size: 11px; margin:0"> &copy; <a target="_blank" href="https://www.sanatteknoloji.com.tr">Sanat Teknoloji</a> tarafından geliştirilmiştir. <div/>',
          url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png'
        },
      ],
    }
  },
  computed: {
    crs() {
      return this.crss[this.crsIndex]
    }
  },
  watch:{
    addressList:function(){
      this.codeAddress()
    }
  },
  methods: {
    setAnimatedMarker() {
      if(!this.coordsToTrack) return

      const line = L.polyline(this.coordsToTrack).getLatLngs()
      const animatedMarker = animateMarker(line, {
        autoStart: false,
        icon: this.icon,
        distance: 300,
        interval: 1500
      });
      this.map.addLayer(animatedMarker);
      this.animatedMarker = animatedMarker
    },
    start() {
      this.animatedMarker.start()
    },
    stop() {
      this.animatedMarker.stop()
    },
    reset() {
      this.animatedMarker.reset()
    },
    setCRS(val) {
      if(val.name == 'Yandex Maps') return this.crsIndex = 1
      return this.crsIndex = 0
    },
    async codeAddress() {
      if (this.coordinates || this.coordsToTrack) return
      if(this.addressList){
        const provider = new EsriProvider()
        this.centerList = []
        this.iconList = []
        this.addressList.map(async (item) =>{
          const result = await provider.search({ query: item.address.replaceAll('/', '').replaceAll('.','') })
          this.centerList.push([result[0].y, result[0].x])
        })
      }else{
        const provider = new EsriProvider()
        const result = await provider.search({ query: this.address.replaceAll('/', '').replaceAll('.','') })
        this.center = [result[0].y, result[0].x]
      }

    }
  },
  mounted() {
    this.codeAddress()

    this.$nextTick(() => {
      this.map = this.$refs.mapRef.mapObject
      this.setAnimatedMarker()
    });
  }
};
</script>
<style scopped>
.animation-handlers {
  text-align: right;
  margin-bottom: 1rem;
}
.leaflet-control-attribution.leaflet-control {
  font-size: 0;
}  
.leaflet-marker-icon {
	  animation: pulsate 2s ease-out;
	  animation-iteration-count: infinite; 
}

@keyframes pulsate {
  0% { opacity: 0.0;}
  50% {opacity: 0.5;}
  75% { opacity: 1.0;}
  100% {opacity: 0.5;}
}

</style>


// WEBPACK FOOTER //
// src/components/Map.vue